import logging from "utils/logging";
import _ from "lodash";
import {
  selectQuestionEntities,
  getQuestionsForRound,
} from "../question/questionSlice";
import {
  selectGameObject,
  selectGameStatusObject,
} from "features/gamestate/gameStateSlice";
import { createSelector } from "@reduxjs/toolkit";
import Provider from "provider";

const log = logging.getLogger("GameBoard-slice"); //eslint-disable-line no-unused-vars

/* ----- Actions ------- */

const beginQuestionAction = (gameId, _gameState, questionId) => async () => {
  try {
    await Provider.selectQuestion(gameId, questionId);
  } catch (error) {
    log.error("Failed to select question", error);
  }
};

const beginDailyDoubleAction = (gameId, _gameState, questionId) => async () => {
  // Route DD through question.selected first for host buildup narration.
  // The dailyDouble flag is NOT set here to prevent spoiling the reveal on
  // player devices. QuestionSelected.onComplete will detect the DD from the
  // question object and transition to dailyDouble.picked with the flag.
  try {
    await Provider.selectQuestion(gameId, questionId);
  } catch (error) {
    log.error("Failed to select daily double", error);
  }
};

export { beginQuestionAction, beginDailyDoubleAction };
/* ------ Selectors ------- */

const selectQuestionObjectsForBoard = createSelector(
  [selectGameStatusObject, selectGameObject, selectQuestionEntities],
  (gameState, game, questions) => {
    let categoryData;
    switch (gameState.currentState) {
      case "round":
        categoryData = game.categories?.[gameState.round];
        break;
      default:
        return null;
    }

    return getQuestionsForRound(categoryData, questions);
  }
);

const selectQuestionObjectsForClueSelector = createSelector(
  [selectGameStatusObject, selectGameObject, selectQuestionEntities],
  (gameState, game, questions) => {

    if (!gameState || !game || !questions || _.isEmpty(questions)) {
      return null;
    }

    const round = gameState.round;

    const categoryData = game.categories?.[round];

    if (!categoryData) {
      return null;
    }

    let output = [];

    const categoryArray = Array.isArray(categoryData) ? categoryData : Object.values(categoryData);

    categoryArray.forEach((category) => {
      let categoryObj = {
        label: category.category || "Unknown",
        questions: []
      }

      for (let i = 1; i <= 5; i++) {
        if (category[i]) {
          const questionId = category[i];
          const question = questions[questionId];
          if (question) {
            categoryObj.questions.push(question);
          }
        }
      }

      output.push(categoryObj);
    });

    return output;
  }
);

export { selectQuestionObjectsForBoard, selectQuestionObjectsForClueSelector };
